import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../../core/styles.constants';

export const dashboardCard = (withOnClick: boolean, isMobile: boolean): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 10,
  height: 200,
  width: isMobile ? '100%' : 200,
  background: StyleConstants.WHITE_COLOR,
  boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
});

export const infoCard = (withOnClick: boolean): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 16,
  background: StyleConstants.WHITE_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
});

export const actionCard = (withOnClick: boolean): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 8,
  background: StyleConstants.PINK_COLOR,
  boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
});

export const cardHeader: CSSProperties = {
  marginBottom: 8,
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const dashboardIcon: CSSProperties = {
  color: StyleConstants.GREY_COLOR,
  minHeight: 50,
  minWidth: 50,
};

export const actionIcon = (isLight: boolean): CSSProperties => ({
  color: isLight ? StyleConstants.WHITE_COLOR : StyleConstants.PINK_COLOR,
  maxHeight: 25,
  maxWidth: 25,
});

export const floatingRow: CSSProperties = {
  maxHeight: 0,
};

export const floatingActionIcon = (isLight: boolean): CSSProperties => ({
  color: isLight ? StyleConstants.WHITE_COLOR : StyleConstants.PINK_COLOR,
  position: 'absolute',
  minHeight: 50,
  minWidth: 50,
});

export const dashboardSubCard = (withOnClick: boolean): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 12,
  background: StyleConstants.WHITE_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
});

export const actionBody: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.WHITE_COLOR,
  width: '100%',
};

export const cardBody: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  width: '100%',
  padding: 8,
};

export const cardTitle: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const checkIcon = (isChecked: boolean): CSSProperties => ({
  color: StyleConstants.ORANGE_COLOR,
  minHeight: 14,
  minWidth: 14,
  maxHeight: 14,
  maxWidth: 14,
  opacity: isChecked ? 1 : 0,
});
